/**
 * ehr#477 (Chase): one color per note status, wherever a note's status shows as a pill: Draft
 * yellow, Pending Review blue, Changes requested red, Signed green, Co-signed teal. The tone is a
 * class (ns-<status>, styles.css) so each place keeps its own pill shape.
 */
export const NOTE_STATUS_LABEL: Record<string, string> = {
  draft: 'Draft',
  pending: 'Pending Review',
  changes: 'Changes requested',
  cosigned: 'Co-signed',
  signed: 'Signed', // ehr#189: signed off by the clinician alone (Supervision off)
};

/** The tone class for a status; anything else (a plan's own status, "No note yet") is grey. */
export const noteStatusClass = (status: string | null | undefined): string =>
  status && Object.prototype.hasOwnProperty.call(NOTE_STATUS_LABEL, status)
    ? `ns-${status}`
    : 'ns-other';

export const noteStatusLabel = (status: string): string =>
  Object.prototype.hasOwnProperty.call(NOTE_STATUS_LABEL, status)
    ? NOTE_STATUS_LABEL[status]!
    : status;

/** A note's status as the list pill (cn-badge), colored by status. */
export function NoteStatusPill({
  status,
  className = 'cn-badge',
}: {
  status: string;
  /** The pill's shape class; the color comes from the status. */
  className?: string;
}) {
  return (
    <span className={`${className} ${noteStatusClass(status)}`}>{noteStatusLabel(status)}</span>
  );
}
